import { STAGE } from 'src/config';

const nodeTypeBindleLockMapping = new Map();

nodeTypeBindleLockMapping.set(
	'p2r_fc',
	'amzn1.bindle.resource.4uaavs7orparounixyjq'
); //Bindle Lock https://bindles.amazon.com/resource/Bindle/Lock/snow_requirement_submission_p2r
nodeTypeBindleLockMapping.set(
	'hardware',
	'amzn1.bindle.resource.egyeotwkvxdecibds75q'
); //Bindle Lock https://bindles.amazon.com/resource/Bindle/Lock/snow_hardware_calculation
nodeTypeBindleLockMapping.set(
	'rad',
	'amzn1.bindle.resource.pzpyanjczzrmep5io6kq'
); //Bindle Lock https://bindles.amazon.com/resource/Bindle/Lock/snow_requirement_submission_rad
nodeTypeBindleLockMapping.set(
	'dockmaster',
	'amzn1.bindle.resource.u7mxcpka6ehfpz7nkjxa'
); //Bindle Lock https://bindles.amazon.com/resource/Bindle/Lock/snow_requirement_submission_dockmaster
nodeTypeBindleLockMapping.set(
	'reconfig',
	'amzn1.bindle.resource.pjnbjluby6j3zkxghyea'
); //Bindle Lock https://bindles.amazon.com/resource/Bindle/Lock/snow_requirement_fc_reconfig
nodeTypeBindleLockMapping.set(
	'snow_team_internal',
	'amzn1.bindle.resource.coapgzkaklv374zdnpvq'
); //Bindle Lock https://bindles.amazon.com/resource/Bindle/Lock/snow_team_internal
nodeTypeBindleLockMapping.set(
	'application_management',
	'amzn1.bindle.resource.5tmxq4wjhxndusafvukq'
); //Bindle Lock https://bindles.amazon.com/resource/Bindle/Lock/application_management
nodeTypeBindleLockMapping.set(
	'attribute_management',
	'amzn1.bindle.resource.7iykq4omfpu4legiavka'
); //Bindle Lock https://bindles.amazon.com/resource/Bindle/Lock/attribute_management
nodeTypeBindleLockMapping.set(
	'node_address_update',
	'amzn1.bindle.resource.h7ggqv7jv2mzkzah2o3q'
); //Bindle Lock https://bindles.amazon.com/resource/Bindle/Lock/node_address_update
nodeTypeBindleLockMapping.set(
	'anchor_point',
	'amzn1.bindle.resource.odclbts5zjw2niaklqra'
); //Bindle Lock https://bindles.amazon.com/resource/Bindle/Lock/node_address_update
nodeTypeBindleLockMapping.set(
	'sorter',
	'amzn1.bindle.resource.4hinrc5n6i7zwr32crha'
); //Bindle Lock https://bindles.amazon.com/resource/Bindle/Lock/snow_requirement_sorter

export const getBindleLockForNodeType = function getBindleLockForNodeType(
	nodeType
) {
	if (nodeTypeBindleLockMapping.has(nodeType)) {
		return nodeTypeBindleLockMapping.get(nodeType);
	}
};

export const getAllBindleLocks = function getAllBindles() {
	return Array.from(nodeTypeBindleLockMapping.values());
};

export function getBindleLockAuthorizationRequest(bindleLockList) {
	return {
		type: 'Lock',
		namespace: 'Bindle',
		action: 'Unlock',
		ids: bindleLockList,
	};
}

export const OLAF_WORKFLOW_BINDLE_DATA = {
	type: 'workflows',
	namespace: 'OLAF',
	action: 'execute',
};

// Copy Workflow Bindle Lock
// https://bindles.amazon.com/resource/Bindle/Lock/snow_copy_workflow
export const COPY_WORKFLOW_BINDLE_ID =
	'amzn1.bindle.resource.xqu3pf4vbmr6nlwltjvq';

export function getCopyWorkflowBindleAuthorizationRequest() {
	return {
		type: 'SoftwareApp',
		namespace: 'Bindle',
		action: 'Can Manage',
		ids: [COPY_WORKFLOW_BINDLE_ID],
	};
}

// Create Workflow Bindle - OLAF SoftwareApp
// Prod: https://bindles.amazon.com/software_app/OLAF
// Alpha/Beta/Dev: https://bindles.amazon.com/resource/amzn1.bindle.resource.iuqxztxaglyejm6oyb7a
// Gamma: https://bindles-gamma.amazon.com/software_app/OLAF-SNOW-Test
const CREATE_WORKFLOW_BINDLE_IDS = {
	prod: 'amzn1.bindle.resource.2wu677nvbu4socy4hliq',
	gamma: 'amzn1.bindle.resource.7dtxvbptydti4wr4mcja',
	default: 'amzn1.bindle.resource.iuqxztxaglyejm6oyb7a',
};

function getCreateWorkflowBindleId(currentStage) {
	if (currentStage === STAGE.PROD) return CREATE_WORKFLOW_BINDLE_IDS.prod;
	if (currentStage === STAGE.GAMMA) return CREATE_WORKFLOW_BINDLE_IDS.gamma;
	return CREATE_WORKFLOW_BINDLE_IDS.default;
}

export function getCreateWorkflowBindleAuthorizationRequest(currentStage) {
	return {
		type: 'SoftwareApp',
		namespace: 'Bindle',
		action: 'Can Manage',
		ids: [getCreateWorkflowBindleId(currentStage)],
	};
}

export const SNOW_INTERNAL_BINDLE = 'snow_team_internal';

export const AUTHORISE_ERROR =
	'Error in authorising the user. Refresh the page...';
